module.exports = __webpack_public_path__ + "img/serum-card-ru.30f5b8ff.jpg";